import Container from '@/app/_components/container';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export const BannerWelfare = () => {
  return (
    <Container className="w-full bg-yellow-100 py-2 text-yellow-700 lg:py-3">
      <div className="flex items-center justify-start gap-2 text-sm lg:text-base">
        <ExclamationCircleIcon className="size-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Attenzione: gli orari mostrati potrebbero non essere aggiornati in tempo reale.</p>
          <p className="font-normal">
            Dopo la richiesta di prenotazione, attendi l&apos;e-mail di conferma o di essere ricontattato dalla clinica.
          </p>
        </div>
      </div>
    </Container>
  );
};
